
import * as messages from '@radnuc/messages';
import { uuidToString } from '@radnuc/react-ui-components';
import { BioInvestigation } from '../components/BioInvestigationDisplay'

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;; //BioInvestigation;
export function dismissInvestigation(inv: Investigation) {
    const state = { dismissed: true, inv_date: new Date(inv.start_time).toLocaleString()}
    window.localStorage.setItem('inv-'+uuidToString(inv.id), JSON.stringify(state));
}

export function syncInvestigationList(invs: Investigation[]): Investigation[] {
    // Remove outdated investigations from storage to save data

    const allInvs = invs.map((inv: Investigation) => 'inv-'+uuidToString(inv.id));
    // Build array of keys first, so we're not modifyin while looping
    const allKeys = [...Array(window.localStorage.length)].map((_, i) => window.localStorage.key(i));

    //Delete only investigations
    allKeys.forEach((key: string | null) => {
        if (!allInvs.includes(key!) && key!.includes('inv-')) {
            window.localStorage.removeItem(key!);
        }
    })

    // Filter investigation list to remove
    return invs.filter((inv: Investigation) => {
        const stateData = window.localStorage.getItem('inv-'+uuidToString(inv.id));
        if (stateData == null)
            return true;

        const state = JSON.parse(stateData);
        return !state.dismissed;
    })
}

export function collapsedInvestigations(invs: Investigation[]): Investigation[] {
    const allInvs = invs.map((inv: Investigation) => 'collapsed-'+uuidToString(inv.id));
    // Build array of keys first, so we're not modifyin while looping
    const allKeys = [...Array(window.localStorage.length)].map((_, i) => window.localStorage.key(i));

    //Delete only investigations
    allKeys.forEach((key: string | null) => {
        if (!allInvs.includes(key!) && key!.includes('collapsed-')) {
            window.localStorage.removeItem(key!);
        }
    })
    // Filter investigation list to remove
    return invs.filter((inv: Investigation) => {
        const stateData = window.localStorage.getItem('collapsed-'+uuidToString(inv.id));
        if (stateData == null)
            return false;

        const state = JSON.parse(stateData);
        return state.collapsed;
    })
}

export function setCollapseInvestigation(inv: Investigation, flag:boolean) {
    if(flag){
        const state = { collapsed: true }
        window.localStorage.setItem('collapsed-'+uuidToString(inv.id), JSON.stringify(state));
    } else {
        window.localStorage.removeItem('collapsed-'+uuidToString(inv.id));
    }
}
